import React, { useState } from 'react';
import OtpInput from 'react-otp-input';
import { Button, isMobileDevice } from 'utils';

import styles from './otp.module.scss';

function Otp({phone, loading, error,otpSuccess,reSendOTP, onSubmit }) {
    const [otp, setOtp] = useState('');
    const [reSend, setResend] = useState(false);
    const isMobile = isMobileDevice();
    const height = 0.32 * window.screen.width;

    function handleOtp(val) {
        setOtp((prev) =>
            process.env.JEST_WORKER_ID ? prev + String(val)[0] : val
        );
    }
    function SendOTP() {
        setResend(true)
        reSendOTP(phone);
        setOtp('')
    }


    return (
        <div className={styles.wrapper}>
            <p className={styles.title}>Sign in</p>
            <p className={styles.subTitle}>Enter your OTP</p>
            {reSend && otpSuccess && <p className={styles.subTitle}>{otpSuccess}</p>}
            <OtpInput
                containerStyle={styles.inputWrapper}
                inputStyle={styles.inputBox}
                focusStyle={styles.focusStyle}
                isInputNum={true}
                value={otp}
                onChange={handleOtp}
                numInputs={6}
                separator={''}
            />
            <Button
                loading={loading}
                label={'Login'}
                className={styles.button}
                width={isMobile ? 200 : height < 380 ? 300 : 340}
                disabled={!(otp.length === 6) }
                onClick={() => onSubmit(otp)}
            />
            
            {otp.length === 6 && error && <p className={styles.error}>{error}</p>}
            {otp.length === 6 && error && <p className={styles.subTitle}>OR <span onClick={() => SendOTP()}>Re-Send OTP</span></p>}
            
        </div>
    );
}

export default Otp;
